// B-104 — "Descargar Drive de mañana", in "Cuadre del día": the cashiers' Excel for the next business
// day, each office opening on today's closing balance. The backend builds it (`downloadCierreNextDayDrive`)
// and names it for the next business day; the operator uploads it to SharePoint by hand. When an office
// has no closing balance today nothing is generated, and the offices are listed here.
import { useState } from "react";
import { Download } from "lucide-react";
import { Button, Spinner } from "@mantis-sas/ui";

import { downloadCierreNextDayDrive } from "../../../ApiCalls/mantisBusiness";
import { correctionError } from "../../../utils/cierreCorrections";
import { guia } from "../../../utils/cierreTours";

export function DescargarDriveManana({ token, mantisBusinessId, clientCode, fecha }) {
  const [trabajando, setTrabajando] = useState(false);
  const [error, setError] = useState(null);
  const [faltantes, setFaltantes] = useState([]);

  const descargar = async () => {
    setTrabajando(true);
    setError(null);
    setFaltantes([]);
    const res = await downloadCierreNextDayDrive(token, mantisBusinessId, clientCode, fecha).catch(() => null);
    setTrabajando(false);
    if (res?.success && res.blob) {
      const { saveAs } = await import("file-saver");
      saveAs(res.blob, res.filename);
      return;
    }
    setFaltantes(res?.data?.oficinasSinSaldo || []);
    setError(correctionError(res) || "No se pudo generar el Drive de mañana.");
  };

  return (
    <div className="space-y-2">
      <Button {...guia("Descargar Drive de mañana", "Descarga el Excel que usan los cajeros el siguiente día hábil, con el saldo de cierre de cada oficina. Si a alguna le falta el saldo, te dice cuáles.")} variant="outline" size="sm" className="h-8 gap-1.5" disabled={trabajando} onClick={descargar}>
        {trabajando ? <Spinner size="sm" /> : <Download className="h-4 w-4" />} Descargar Drive de mañana
      </Button>
      {error ? (
        <div role="alert" className="rounded-[8px] border border-brinks-danger-border bg-brinks-danger-soft px-3 py-2 text-[12px] text-brinks-danger">
          <p className="font-medium">{error}</p>
          {faltantes.length ? (
            <ul className="mt-1 list-disc pl-5">
              {faltantes.map((oficina) => (
                <li key={oficina.officeCode}>
                  {oficina.officeCode} {oficina.officeName}
                  {oficina.sinCierre ? " (sin cierre ese día)" : ""}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default DescargarDriveManana;
